module.exports = __webpack_public_path__ + "img/typehoon50.9f5b86a9.jpg";